import React, { useReducer, createContext, useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";

import "./App.css";

import LoginPage from "./login/LoginPage";
import HomePage from "./home/Home";

export const AuthContext = createContext();

const STORAGE_KEYS = {
  profileId: "profileId",
  token: "token",
};

const initialState = {
  isAuthenticated: false,
  user: null,
  token: null,
};

// Lazy initializer: runs BEFORE first render so refresh on /home won't redirect
function initAuthState() {
  try {
    const user = localStorage.getItem(STORAGE_KEYS.profileId);
    const token = localStorage.getItem(STORAGE_KEYS.token);

    if (user && token) {
      return {
        isAuthenticated: true,
        user,
        token,
      };
    }
  } catch (e) {
    console.warn("Auth init failed:", e);
  }
  return initialState;
}

const reducer = (state, action) => {
  switch (action.type) {
    case "LOGIN": {
      const { user, token } = action.payload;

      // Persist consistently
      localStorage.setItem(STORAGE_KEYS.profileId, user);
      localStorage.setItem(STORAGE_KEYS.token, token);

      return { ...state, isAuthenticated: true, user, token };
    }

    case "LOGOUT": {
      localStorage.removeItem(STORAGE_KEYS.profileId);
      localStorage.removeItem(STORAGE_KEYS.token);
      return { ...state, isAuthenticated: false, user: null, token: null };
    }

    default:
      return state;
  }
};

function App() {
  const [state, dispatch] = useReducer(reducer, initialState, initAuthState);

  useEffect(() => {
    // Safe cache clear: won't crash browsers where caches isn't available
    (async () => {
      try {
        if ("caches" in window && window.caches?.keys) {
          const names = await window.caches.keys();
          await Promise.all(names.map((name) => window.caches.delete(name)));
        }
      } catch (e) {
        console.warn("Cache clear skipped:", e);
      }
    })();
  }, []);

  return (
    <AuthContext.Provider value={{ state, dispatch }}>
      <Router>
        <div className="App">
          <Switch>
            <Route exact path="/" component={LoginPage} />

            <Route
              path="/home"
              render={() =>
                state.isAuthenticated ? <HomePage /> : <Redirect to="/" />
              }
            />

            <Route path="/ss" component={LoginPage} />

            <Route render={() => <Redirect to="/" />} />
          </Switch>
        </div>
      </Router>
    </AuthContext.Provider>
  );
}

export default App;
